import type { CycloneConfig } from "@voxmedia/duet-context/context/config-context";

if (!process.env.NEXT_PUBLIC_CYCLONE_SERVER_URL) {
  throw new Error("NEXT_PUBLIC_CYCLONE_SERVER_URL env variable is required");
}

export const CYCLONE_SERVER_URL = process.env.NEXT_PUBLIC_CYCLONE_SERVER_URL;

export const CYCLONE_ENABLED =
  process.env.NEXT_PUBLIC_CYCLONE_ENABLED === "true";

/**
 * Cyclone-comments env default. When true, cyclone is the default provider
 * and per-community metadata (SB Nation only) can override back to coral.
 * When false, coral is the default and per-community metadata can override
 * to cyclone. Set via `duet.config.js` `cycloneCommentsEnabled` →
 * `NEXT_PUBLIC_CYCLONE_COMMENTS_ENABLED` in all environments.
 */
export const CYCLONE_COMMENTS_ENABLED =
  CYCLONE_ENABLED &&
  process.env.NEXT_PUBLIC_CYCLONE_COMMENTS_ENABLED === "true";

// Config used for Config/UI Context
export const cycloneConfig: CycloneConfig = {
  serverURL: CYCLONE_SERVER_URL,
  commentRecThreshold: 5,
  enabled: CYCLONE_ENABLED,
  commentsEnabled: CYCLONE_COMMENTS_ENABLED,
};
